<script>
import Multiselect from 'vue-multiselect';
import switchInput from '../../../components/switch-input.vue';
import {
    FETCH_MERCHANT_ENTITY_DETAILS,
    UPDATE_MERCHANT_ENTITY_DETAILS
} from "@/state/actions.type";
import { maxValue, minValue, required } from 'vuelidate/lib/validators';

// const checkMinMax = (value) => {
//     if(!value) {
//         return false;
//     }

//     let val = parseFloat((Math.round(value.replace('%', '') * 100) / 100).toFixed(2));

//     if((val != 0 && !val) || isNaN(val)) {
//         return false;
//     }

//     if(val < 0 || val > 100) {
//         return false;
//     }

//     return true;
// }

const options = [];
for(let i = 0; i <= 20; i+=0.5) {
    options.push(i);
}

export default {
  components: {
    switchInput,
    Multiselect
  },
  page: {
    title: "Advanced Settings",
  },

  validations: {
    selectedCurrencies: {
        $each: {
            value: {
                required,
                minValue: minValue(0),
                maxValue: maxValue(100)
                // checkMinMax
            },
            currencies: {
                required
            }
        }
    },
    golbalCharge: {
        required,
        minValue: minValue(0),
        maxValue: maxValue(100)
        // checkMinMax
    }
  },

  data() {
    return {
        toggleItems: {
            dynamic_currency_checkout_enabled: false,
            is_dcc_markup_refund_usage_enabled: false,
            is_dcc_markup_factor_usage_enabled: false
        },
        selectedCurrencies: [{
            value: null,
            currencies: []
        }],
        golbalCharge: null,
        currencyMapping: [
            {
                region: 'Asia',
                currencies: [{selected: false, value: "AED"}, {selected: false, value: "AFN"}, {selected: false, value: "AMD"}, {selected: false, value: "AZN"}, {selected: false, value: "BDT"}, {selected: false, value: "BHD"}, {selected: false, value: "BND"}, {selected: false, value: "BTN"}, {selected: false, value: "CNY"}, {selected: false, value: "IDR"}, {selected: false, value: "INR"}, {selected: false, value: "JPY"}, {selected: false, value: "KRW"}, {selected: false, value: "MYR"}, {selected: false, value: "PHP"}, {selected: false, value: "SGD"}, {selected: false, value: "THB"}, {selected: false, value: "VND"}, {selected: false, value: "SAR"}, {selected: false, value: "KWD"}, {selected: false, value: "HKD"}, {selected: false, value: "KZT"}, {selected: false, value: "OMR"}, {selected: false, value: "TRY"}, {selected: false, value: "TWD"}, {selected: false, value: "ILS"}, {selected: false, value: "QAR"}, {selected: false, value: "KHR"}, {selected: false, value: "JOD"}, {selected: false, value: "IQD"}, {selected: false, value: "MVR"}, {selected: false, value: "LAK"}, {selected: false, value: "LKR"}, {selected: false, value: "MMK"}, {selected: false, value: "NPR"}, {selected: false, value: "PKR"},]
            },
            {
                region: 'Europe',
                currencies: [{selected: false, value: "ANG"}, {selected: false, value: "AWG"}, {selected: false, value: "BYN"}, {selected: false, value: "BYR"}, {selected: false, value: "CHF"}, {selected: false, value: "CZK"}, {selected: false, value: "DKK"}, {selected: false, value: "EUR"}, {selected: false, value: "GBP"}, {selected: false, value: "NOK"}, {selected: false, value: "SEK"}, {selected: false, value: "PLN"}, {selected: false, value: "RON"}, {selected: false, value: "HUF"}, {selected: false, value: "ISK"}, {selected: false, value: "XPF"}, {selected: false, value: "JEP"}, {selected: false, value: "GEL"}, {selected: false, value: "UAH"}, {selected: false, value: "ALL"}, {selected: false, value: "BAM"}, {selected: false, value: "BGN"},]
            },
            {
                region: 'Africa',
                currencies: [{selected: false, value: "AOA"}, {selected: false, value: "BIF"}, {selected: false, value: "BWP"}, {selected: false, value: "CDF"}, {selected: false, value: "CVE"}, {selected: false, value: "DJF"}, {selected: false, value: "DZD"}, {selected: false, value: "EGP"}, {selected: false, value: "ERN"}, {selected: false, value: "ETB"}, {selected: false, value: "ZAR"}, {selected: false, value: "TZS"}, {selected: false, value: "XOF"}, {selected: false, value: "SCR"}, {selected: false, value: "MUR"}, {selected: false, value: "GHS"}, {selected: false, value: "KES"}, {selected: false, value: "MAD"}, {selected: false, value: "NGN"}, {selected: false, value: "RWF"}, {selected: false, value: "UGX"},]
            },
            {
                region: 'North America',
                currencies: [{selected: false, value: "CAD"}, {selected: false, value: "USD"}, {selected: false, value: "MXN"}, {selected: false, value: "BZD"}, {selected: false, value: "CRC"}, {selected: false, value: "KYD"}, {selected: false, value: "BMD"},]
            },
            {
                region: 'South America',
                currencies: [{selected: false, value: "ARS"}, {selected: false, value: "BOB"}, {selected: false, value: "BRL"}, {selected: false, value: "CLF"}, {selected: false, value: "CLP"}, {selected: false, value: "COP"}, {selected: false, value: "FKP"}, {selected: false, value: "PEN"}, {selected: false, value: "PYG"},]
            },
            {
                region: 'Caribbean',
                currencies: [{selected: false, value: "BBD"}, {selected: false, value: "BSD"}, {selected: false, value: "CUC"}, {selected: false, value: "CUP"}, {selected: false, value: "DOP"}, {selected: false, value: "XCD"}, {selected: false, value: "TTD"},]
            },
            {
                region: 'Oceania',
                currencies: [{selected: false, value: "AUD"}, {selected: false, value: "FJD"}, {selected: false, value: "NZD"},]
            }
        ],
        valueOptions: options,
        preselectedCurrencies: [],
        processing: false
    }
  },

  created() {
    this.$store.dispatch(`merchant/${FETCH_MERCHANT_ENTITY_DETAILS}`).then(() => {
        this.setToggleItems();
        this.setMarkup();
    });
  },

  filters: {
    currencyFullForm(currency) {
        return new Intl.DisplayNames(['en'], {type: 'currency'}).of(currency);
    },
    getCurrencySymbol(currency) {
        return (0).toLocaleString(
            'EN-US',
            {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
            }
        ).replace(/\d/g, '').trim()
    }
  },

  computed: {
    entityDetails() {
      return this.$store.state.merchant.entityDetails;
    },
  },

  methods: {
    setToggleItems() {
        this.toggleItems = {
            dynamic_currency_checkout_enabled: this.entityDetails.dynamic_currency_checkout_enabled,
            is_dcc_markup_refund_usage_enabled: this.entityDetails.is_dcc_markup_refund_usage_enabled,
            is_dcc_markup_factor_usage_enabled: this.entityDetails.is_dcc_markup_factor_usage_enabled
        };
    },
    setMarkup() {
        let markupGroup = {};

        this.selectedCurrencies = [];

        for(let key of Object.keys(this.entityDetails.dcc_markup_factors_by_currency)) {
            // let v = `${this.entityDetails.dcc_markup_factors_by_currency[key]}%`;
            let v = this.entityDetails.dcc_markup_factors_by_currency[key];
            if(key === "GLOBAL") {
                this.golbalCharge = v;
            } else {
                if(!markupGroup[v]) {
                    markupGroup[v] = [key];
                } else {
                    markupGroup[v].push(key);
                }
            }
        }

        this.currencyMapping.map((regionalMapping) => {
            regionalMapping.currencies.map(currency => {
                currency.selected = false;
            })
        });

        for(let val of Object.keys(markupGroup)) {
            let v = parseFloat(val);
            let currencyObj = {
                value: v,
                currencies: []
            };

            this.currencyMapping.map((regionalMapping) => {
                regionalMapping.currencies.map(currency => {
                    if(markupGroup[v].includes(currency.value)) {
                        currency.selected = true;
                        currencyObj.currencies.push(currency);
                    }
                })
            })
            this.selectedCurrencies.push(currencyObj);

        }
    },
    currencyRemoved(value) {
        if(Array.isArray(value)) {
            for(let item of value) {
                item.selected = false;
            }
        } else {
            value.selected = false;
        }
    },
    currencySelected(value, index) {
        if(Array.isArray(value)) {
            this.preselectedCurrencies = value.filter((item) => {
                if(item.selected && !this.selectedCurrencies[index].currencies.includes(item)) {
                    return true;
                }
                item.selected = true;
                return false;
            });
            
        } else {
            value.selected = true;
        }
    },
    removePreselectedCurrencies(value, index) {
        if(this.preselectedCurrencies.length > 0) {
            this.selectedCurrencies[index].currencies = value.filter((item) => !this.preselectedCurrencies.includes(item));

            this.preselectedCurrencies = [];
        }
    },
    addCurrencyGroup() {
        this.selectedCurrencies.push({
            value: null,
            currencies: []
        });
    },
    removeCurrencyGroup(index) {
        for(let currency of this.selectedCurrencies[index].currencies) {
            currency.selected = false;
        }

        this.selectedCurrencies.splice(index, 1);
    },
    checkGroupSelected(region, selectedCurrency) {
        let currencies = [];
        for(let el of this.currencyMapping) {
            if(el.region === region) {
                el.selected = true;
                currencies = el.currencies;
                break;
            }
        }
        let selected = true;
        for(let currency of currencies) {
            if(selectedCurrency.currencies.includes(currency) || !currency.selected) {
                selected = false;
                break;
            }
        }

        return selected;
    },
    allSelected(region, selectedCurrencies) {
        let currencies = [];
        for(let el of this.currencyMapping) {
            if(el.region === region) {
                el.selected = true;
                currencies = el.currencies;
                break;
            }
        }

        let selected = true;
        for(let currency of currencies) {
            if(!selectedCurrencies.includes(currency)) {
                selected = false;
                break;
            }
        }

        return selected;
    },
    saveConfig() {
        this.$v.golbalCharge.$touch();
        this.$v.selectedCurrencies.$touch();

        if(this.$v.$error) {
            return false;
        }

        let markup = {
            GLOBAL: parseFloat(this.golbalCharge)
        }

        this.selectedCurrencies.map(el => {
            el.currencies.map(currency => markup[currency.value] = parseFloat(el.value));
        });

        this.processing = true;
        this.$store.dispatch(`merchant/${UPDATE_MERCHANT_ENTITY_DETAILS}`, {
            dcc_markup_factors_by_currency: markup
        }).then(() => {
            this.$notify({
            type: 'success',
            text: 'Changes Saved Successfully',
            closeOnClick: true,
            });
        })
        .catch((error) => {
            // error
            console.log("error", error);
            this.setToggleItems();
        })
        .finally(() => {
            this.processing = false;
        });
        
    },
    resetConfig() {
        this.setMarkup();
    },
    // formatGlobalCharge() {
    //     if(this.golbalCharge) {
    //         let val = this.golbalCharge.replace('%', '');
    //         if(val) {
    //             let charge = this.floatParser(val);
    
    //             if(!isNaN(charge)) {
    //                 this.golbalCharge = charge + "%";
    //             } else {
    //                 this.golbalCharge = charge;
    //             }
    //         } else {
    //             this.golbalCharge = null;
    //         }
    //     }
    // },
    // formatCharge(index) {
    //     if(this.selectedCurrencies[index].value) {
    //         let val = this.selectedCurrencies[index].value.replace('%', '').replace('%', '');
    //         if(val) {
    //             let charge = this.floatParser(val);
                
    //             if(!isNaN(charge)) {
    //                 this.selectedCurrencies[index].value = charge + "%";
    //             } else {
    //                 this.selectedCurrencies[index].value = charge;
    //             }
    //         } else {
    //             this.selectedCurrencies[index].value = null;
    //         }
    //     }
    // },
    floatParser(n) {
        return parseFloat((Math.round(n * 100) / 100).toFixed(2));
    },
    addTag(newTag, id) {
        let v = this.floatParser(newTag);

        // if(v < 0 || v > 100) {
        //     return;
        // }

        if(!isNaN(v)) {
            // if(!this.valueOptions.includes(v)) {
            //     let idx = this.valueOptions.findIndex((val) => val > v);
            //     if(idx == -1) {
            //         this.valueOptions.push(v);
            //     } else {
            //         this.valueOptions.splice(idx, 0, v);
            //         this.valueOptions.join()
            //     }
            // }
            if(id == "golbalCharge") {
                this.golbalCharge = v;
            } else {
                this.selectedCurrencies[id].value = v;
            }
        } else {
            if(id == "golbalCharge") {
                this.golbalCharge = null;
            } else {
                this.selectedCurrencies[id].value = null;
            }
        }

    },
    updateToggle(key) {
        if(this.entityDetails[key] !== this.toggleItems[key]) {
            const payload = {};
            payload[key] = this.toggleItems[key];

            this.$store.dispatch(`merchant/${UPDATE_MERCHANT_ENTITY_DETAILS}`, payload).then(() => {
              this.$notify({
                type: 'success',
                text: 'Changes Saved Successfully',
                closeOnClick: true,
              });
            })
            .catch((error) => {
                // error
              console.log("error", error);
            })
            .finally(() => {
                this.setToggleItems();
                if(key !== "is_dcc_markup_refund_usage_enabled") {
                    this.setMarkup();
                }
            });
        }
    },
    globalChargeOpen() {
        if(this.golbalCharge == 0 || this.golbalCharge) {
            this.$refs['golbalCharge'].search = String(this.golbalCharge);
        }
    },
    markupOpen(id) {
        if(this.selectedCurrencies[id].value == 0 || this.selectedCurrencies[id].value) {
            this.$refs[`markup${id}`][0].search = String(this.selectedCurrencies[id].value);
        }
    },
    validateState(name) {
        const { $dirty, $error } = this.$v.toggleItems[name];
        return $dirty ? !$error : null;
    },
  }
};
</script>

<template>
    <div>
        <div class="toggle-settings">
            <div class="d-flex" style="gap: 15px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="p-2" style="border-radius: var(--8, 8px); background: rgba(220, 218, 213, 0.30);" viewBox="0 0 24 24" fill="none">
                    <path d="M16.8983 10.2521C16.8899 10.2168 16.8662 10.1859 16.8323 10.1661C16.7984 10.1463 16.7571 10.1392 16.7174 10.1463C16.5306 10.1859 16.3394 10.2066 16.1474 10.208C15.8135 10.2088 15.4876 10.1174 15.2147 9.94641C14.9417 9.77547 14.7351 9.53341 14.6233 9.25362H16.0482C16.0825 9.25354 16.1157 9.24331 16.1426 9.22454C16.1695 9.20577 16.1887 9.17955 16.1969 9.15002L16.2762 8.83261C16.2811 8.81291 16.2809 8.79249 16.2756 8.77287C16.2704 8.75325 16.2602 8.73493 16.246 8.71927C16.2317 8.7036 16.2136 8.691 16.1931 8.68238C16.1726 8.67377 16.1502 8.66936 16.1275 8.66949H14.4448C14.4275 8.51264 14.4275 8.35465 14.4448 8.19779H16.2837C16.3179 8.19749 16.351 8.18686 16.3776 8.16764C16.4041 8.14842 16.4226 8.12174 16.4299 8.09199L16.5117 7.76135C16.5148 7.74265 16.5135 7.72357 16.5078 7.70535C16.5021 7.68713 16.4921 7.67019 16.4786 7.65563C16.465 7.64107 16.4481 7.62921 16.4291 7.62084C16.41 7.61247 16.3892 7.60778 16.3679 7.60705H14.6332C14.7582 7.35332 14.965 7.13829 15.2275 6.98919C15.49 6.84008 15.7963 6.76361 16.1077 6.76945C16.2676 6.77183 16.4269 6.78732 16.5835 6.81574C16.6212 6.82251 16.6604 6.81625 16.6931 6.79823C16.7258 6.78021 16.7495 6.75179 16.7595 6.71875L16.9082 6.225C16.9137 6.20718 16.915 6.18854 16.912 6.17024C16.9091 6.15194 16.9019 6.13439 16.891 6.11867C16.88 6.10295 16.8656 6.0894 16.8485 6.07887C16.8314 6.06834 16.8121 6.06106 16.7917 6.05748C16.5734 6.02125 16.352 6.00207 16.13 6.00017C15.5668 5.9942 15.0159 6.14625 14.5554 6.43472C14.0949 6.72319 13.7484 7.1334 13.5651 7.60705H13.1487C13.129 7.60705 13.1094 7.61054 13.0912 7.61733C13.073 7.62411 13.0565 7.63405 13.0427 7.64657C13.0288 7.65908 13.0179 7.67392 13.0106 7.69022C13.0033 7.70653 12.9997 7.72396 13 7.74151V8.07215C12.9997 8.0897 13.0033 8.10714 13.0106 8.12344C13.0179 8.13974 13.0288 8.15458 13.0427 8.16709C13.0565 8.17961 13.073 8.18955 13.0912 8.19633C13.1094 8.20312 13.129 8.20661 13.1487 8.20661H13.4213C13.4077 8.36361 13.4077 8.52131 13.4213 8.67831H13.1487C13.129 8.67831 13.1094 8.6818 13.0912 8.68859C13.073 8.69537 13.0565 8.70531 13.0427 8.71782C13.0288 8.73034 13.0179 8.74518 13.0106 8.76148C13.0033 8.77778 12.9997 8.79522 13 8.81277V9.12797C12.9997 9.14553 13.0033 9.16296 13.0106 9.17926C13.0179 9.19556 13.0288 9.21041 13.0427 9.22292C13.0565 9.23544 13.073 9.24538 13.0912 9.25216C13.1094 9.25894 13.129 9.26244 13.1487 9.26243H13.518C13.6697 9.76967 14.0088 10.2168 14.4807 10.5318C14.9527 10.8469 15.5301 11.0116 16.1201 10.9994C16.3792 10.9985 16.6371 10.9696 16.8884 10.9134C16.9252 10.9041 16.9568 10.8829 16.977 10.8539C16.9971 10.825 17.0044 10.7904 16.9974 10.7569L16.8983 10.2521Z" fill="black"/>
                    <path d="M23 15.9697C23 19.8397 19.87 22.9697 16 22.9697L17.05 21.2197" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M1 7.96973C1 4.09973 4.13 0.969727 8 0.969727L6.95 2.71973" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.8517 15.3302C14.8517 18.7402 12.0917 21.5002 8.68172 21.5002C5.27172 21.5002 2.51172 18.7402 2.51172 15.3302C2.51172 11.9202 5.27172 9.16016 8.68172 9.16016C8.84172 9.16016 8.99172 9.17018 9.16172 9.18018C12.1917 9.41018 14.6117 11.8302 14.8417 14.8602C14.8417 15.0102 14.8517 15.1602 14.8517 15.3302Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21.5002 8.66998C21.5002 12.08 18.7402 14.84 15.3302 14.84H14.8402C14.6102 11.81 12.1902 9.38997 9.16016 9.15997V8.66998C9.16016 5.25998 11.9202 2.5 15.3302 2.5C18.7402 2.5 21.5002 5.25998 21.5002 8.66998Z" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M7 16.371C7 17.048 7.51949 17.5937 8.16492 17.5937H9.48201C10.0435 17.5937 10.5 17.1162 10.5 16.5285C10.5 15.8883 10.2219 15.6626 9.80735 15.5157L7.69265 14.7811C7.27811 14.6342 7 14.4085 7 13.7683C7 13.1806 7.45652 12.7031 8.01799 12.7031H9.33508C9.98051 12.7031 10.5 13.2489 10.5 13.9258" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8.74609 12V18.2969" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="my-auto flex-fill section-title">
                    Dynamic Currency checkout Enabled
                </p>
                <switch-input v-model="toggleItems.dynamic_currency_checkout_enabled" @input="updateToggle('dynamic_currency_checkout_enabled')" :value="toggleItems.dynamic_currency_checkout_enabled" />
            </div>
            <hr style="border-color: rgba(220, 218, 213, 0.30); margin-top: 12px; margin-bottom: 12px;">
            <p class="m-0 section-text">
                Enable multi-currency checkout which presents local currencies to your customers.
            </p>
        </div>

        <div v-if="toggleItems.dynamic_currency_checkout_enabled">
            <div class="toggle-settings">
                <div class="d-flex" style="gap: 15px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="p-2" style="border-radius: var(--8, 8px); background: rgba(220, 218, 213, 0.30);" viewBox="0 0 24 24" fill="none">
                        <path d="M9.61024 9.98436C9.81833 10.0604 10.0018 10.2537 10.0983 10.5735C10.1949 10.8934 10.1906 11.3095 10.0346 11.7365C9.87858 12.1634 9.61355 12.4842 9.33343 12.6665C9.05348 12.8487 8.78858 12.8781 8.58049 12.8021C8.3724 12.726 8.1889 12.5327 8.09239 12.213C7.99582 11.893 8.00009 11.4769 8.15612 11.05C8.31215 10.623 8.57718 10.3022 8.8573 10.1199C9.13726 9.93774 9.40215 9.90831 9.61024 9.98436Z" fill="#D9D9D9" stroke="black"/>
                        <path d="M14.6102 10.9844C14.8183 11.0604 15.0018 11.2537 15.0983 11.5735C15.1949 11.8934 15.1906 12.3095 15.0346 12.7365C14.8786 13.1634 14.6136 13.4842 14.3334 13.6665C14.0535 13.8487 13.7886 13.8781 13.5805 13.8021C13.3724 13.726 13.1889 13.5327 13.0924 13.213C12.9958 12.893 13.0001 12.4769 13.1561 12.05C13.3121 11.623 13.5772 11.3022 13.8573 11.1199C14.1373 10.9377 14.4022 10.9083 14.6102 10.9844Z" fill="#D9D9D9" stroke="black"/>
                        <path d="M4.47 11.4197L2.73 9.67969L1 11.4197" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M19.5312 12.5801L21.2712 14.3201L23.0113 12.5801" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21.2595 14.3203V12.0002C21.2595 6.88024 17.1095 2.74023 11.9995 2.74023C9.07953 2.74023 6.46953 4.10027 4.76953 6.21027" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.73828 9.67969V11.9997C2.73828 17.1197 6.88828 21.2597 11.9983 21.2597C14.9183 21.2597 17.5283 19.8997 19.2283 17.7897" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13 8L10 16" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="flex-fill">
                        <p class="my-auto section-title" style="line-height: 20px;">
                            Enable DCC Markup
                        </p>
                        <p class="mb-0 mt-1 section-text" style="line-height: 16px;">
                            Enable multi-currency checkout which presents local currencies to your customers.
                        </p>
                    </div>
                    <switch-input v-model="toggleItems.is_dcc_markup_factor_usage_enabled" @input="updateToggle('is_dcc_markup_factor_usage_enabled')" :value="toggleItems.dynamic_currency_checkout_enabled" />
                </div>
    
                <div v-if="toggleItems.is_dcc_markup_factor_usage_enabled" class="mt-3 py-3 px-4" style="border-radius: 12px 12px 0 0; border: 1px solid rgba(220, 218, 213, 0.50); border-bottom: 0; background: rgba(220, 218, 213, 0.10);">
                    <div class="p-3 mb-4" style="border-radius: 12px; border: 1px solid rgba(252, 107, 45, 0.32); background: rgba(248, 88, 19, 0.06);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="mr-3">
                            <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#FC6B2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 8V13" stroke="#FC6B2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.9961 16H12.0051" stroke="#FC6B2D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="text-chai" style="font-size: 14px; line-height: 20px;">Configure payment channel before setting up the DCC markup.</span>
                    </div>

                    <div class="d-flex">
                        <div class="d-flex mb-auto" style="border-radius: 12px; border: 1px solid #DCDAD5; background: #FFF; width: 504px; margin-right: 12px; padding: 11px 8px;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="mr-2" style="opacity: 0.5;">
                                <path d="M18.3346 10.0003C18.3346 5.40032 14.6013 1.66699 10.0013 1.66699C5.4013 1.66699 1.66797 5.40032 1.66797 10.0003C1.66797 14.6003 5.4013 18.3337 10.0013 18.3337" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M6.66667 2.5H7.5C5.875 7.36667 5.875 12.6333 7.5 17.5H6.66667" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.5 2.5C13.3083 4.93333 13.7167 7.46667 13.7167 10" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.5 13.3333V12.5C4.93333 13.3083 7.46667 13.7167 10 13.7167" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M2.5 7.5C7.36667 5.875 12.6333 5.875 17.5 7.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.2482 12.2496C15.9398 12.1579 15.5898 12.0996 15.2065 12.0996C13.4815 12.0996 12.0898 13.4996 12.0898 15.2163C12.0898 16.9413 13.4898 18.3329 15.2065 18.3329C16.9232 18.3329 18.3232 16.9329 18.3232 15.2163C18.3232 14.5746 18.1315 13.9746 17.7982 13.4829" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.6979 12.3333L15.6562 11.1416" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.6972 12.333L15.4805 13.2163" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <div class="m-0" style="font-size: 14px; line-height: 20px;">Global Markup</div>
                        </div>

                        <div>
                            <multiselect
                                :placeholder="golbalCharge ? `${golbalCharge}%` : `0%`"
                                v-model.number="golbalCharge"
                                :options="valueOptions"
                                open-direction="bottom"
                                id="golbalCharge"
                                ref="golbalCharge"
                                :taggable="true"
                                @tag="addTag"
                                @open="globalChargeOpen"
                                style="width: 126px;"
                                :class="{'is-invalid': $v.golbalCharge.$error }"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">{{ option }}%</template>
                            </multiselect>

                            <div class="mt-2 font-12px text-danger" v-show="$v.golbalCharge.$error">{{ !$v.golbalCharge.required ? `This field is required` : `Invalid value` }}</div>
                        </div>
                        <!-- <div>
                            <b-input type="text" min="0" max="100" placeholder="0%" class="percent-bg pl-4 pr-4" v-model="golbalCharge" @change="formatGlobalCharge" :class="{'is-invalid': $v.golbalCharge.$error}" @mousewheel.prevent style="border-radius: 12px; border: 1px solid #DCDAD5; background: #FFF; width: 126px; height: 44px;" />
                            <div class="mt-2 font-12px text-danger" v-show="$v.golbalCharge.$error">Invalid Value</div>
                        </div> -->
                    </div>

                    <div class="my-3" v-for="(selectedCurrency, index) in selectedCurrencies" :key="index">
                        <div class="d-flex">
                            <multiselect
                                v-model="selectedCurrency.currencies"
                                :options="currencyMapping"
                                :multiple="true"
                                group-values="currencies"
                                group-label="region"
                                track-by="value"
                                label="value"
                                :group-select="true"
                                :close-on-select="false"
                                open-direction="bottom"
                                placeholder="Type to search"
                                class="currency-multiselect"
                                :id="index"
                                @input="removePreselectedCurrencies"
                                @select="currencySelected"
                                @remove="currencyRemoved"
                                style="width: 504px; margin-right: 12px;"
                                :class="{'is-invalid': $v.selectedCurrencies.$each.$iter[index].currencies.$error }"
                            >
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc" :class="{'ml-4': !props.option.$groupLabel, 'd-none': props.option.$groupLabel ? checkGroupSelected(props.option.$groupLabel, selectedCurrency) : !selectedCurrency.currencies.includes(props.option) && props.option.selected}">
                                        <span class="option__title" v-if="props.option.$groupLabel">
                                            <b-form-checkbox
                                                disabled
                                                :checked="allSelected(props.option.$groupLabel, selectedCurrency.currencies)"
                                                >
                                                <span class="font-14px" style="line-height: 20px; color: #000;">{{ props.option.$groupLabel }}</span>
                                            </b-form-checkbox>
                                        </span>
                                        <span v-else class="option__small">
                                            <b-form-checkbox
                                                disabled
                                                :checked="selectedCurrency.currencies.includes(props.option)"
                                                >
                                                <span class="font-14px" style="line-height: 20px; color: #000;">{{ props.option.value }} - {{ props.option.value | currencyFullForm }} ({{ props.option.value | getCurrencySymbol }})</span>
                                            </b-form-checkbox>
                                        </span>
                                    </div>
                                </template>
                                <span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
                            </multiselect>

                            <multiselect
                                placeholder="0%"
                                v-model.number="selectedCurrency.value"
                                :options="valueOptions"
                                open-direction="bottom"
                                :ref="`markup${index}`"
                                :id="index"
                                :taggable="true"
                                @tag="addTag"
                                @open="markupOpen"
                                style="width: 126px;"
                                :class="{'is-invalid': $v.selectedCurrencies.$each.$iter[index].value.$error }"
                            >
                                <template slot="singleLabel" slot-scope="{ option }">{{ option }}%</template>
                            </multiselect>

                            <b-btn variant="link" class="ml-2 my-auto p-0" @click="removeCurrencyGroup(index)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 12L12 4M12 12L4 4" stroke="#E36464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </b-btn>
                        </div>

                        <div class="d-flex">
                            <div class="mt-2 font-12px text-danger" style="width: 504px; margin-right: 12px;" v-show="$v.selectedCurrencies.$each.$iter[index].currencies.$error">Currency is required</div>

                            <div class="mt-2 font-12px text-danger" style="width: 126px;" v-show="$v.selectedCurrencies.$each.$iter[index].value.$error">{{ !$v.selectedCurrencies.$each.$iter[index].value.required ? `This field is required` : `Invalid value` }}</div>
                        </div>
                        <!-- <div>
                            <b-input type="text" min="0" max="100" placeholder="0%" class="percent-bg pl-4 pr-4" v-model="selectedCurrency.value" @change="formatCharge(index)" @mousewheel.prevent :class="{'is-invalid': $v.selectedCurrencies.$each.$iter[index].value.$error}" style="border-radius: 12px; border: 1px solid #DCDAD5; background: #FFF; width: 126px; height: 44px;" />
                            <div class="mt-2 font-12px text-danger" v-show="$v.selectedCurrencies.$each.$iter[index].value.$error">Invalid Value</div>
                        </div> -->

                    </div>

                    <b-btn class="text-chai p-0 mt-2" variant="link" @click="addCurrencyGroup">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 12H18M12 18V6" stroke="#FC6B2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        Add currency group
                    </b-btn>

                </div>
                <div v-if="toggleItems.is_dcc_markup_factor_usage_enabled" class="bg-white px-4 py-3" style="border-radius: 0 0 12px 12px; border: 1px solid rgba(220, 218, 213, 0.50); border-top: 0; box-shadow: 0px -4px 10px 0px rgba(220, 218, 213, 0.25);">
                    <b-btn variant="primary" :disabled="processing" class="px-4 py-2 font-14px" style="line-height: 20px;" @click="saveConfig">Save</b-btn>
                    <b-btn variant="cancel" :disabled="processing" class="px-4 py-2 font-14px ml-2" style="border: 1px solid #000; line-height: 20px;" @click="resetConfig">Cancel</b-btn>
                </div>

                <div v-if="toggleItems.is_dcc_markup_factor_usage_enabled" class="toggle-settings mt-3">
                    <div class="d-flex" style="gap: 15px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" class="p-2" style="border-radius: var(--8, 8px); background: rgba(220, 218, 213, 0.30);" viewBox="0 0 24 24" fill="none">
                            <path d="M10.0195 4.46997L11.9995 2" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.90939 7.79974C3.79939 9.27974 3.10938 11.1097 3.10938 13.1097C3.10938 18.0197 7.08939 21.9998 11.9994 21.9998C16.9094 21.9998 20.8894 18.0197 20.8894 13.1097C20.8894 8.19974 16.9094 4.21973 11.9994 4.21973C11.3194 4.21973 10.6594 4.30978 10.0194 4.45978" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 14.9412C9 16.0162 9.825 16.8829 10.85 16.8829H12.9417C13.8333 16.8829 14.5583 16.1245 14.5583 15.1912C14.5583 14.1745 14.1167 13.8162 13.4583 13.5829L10.1 12.4162C9.44167 12.1829 9 11.8245 9 10.8079C9 9.87454 9.725 9.11621 10.6167 9.11621H12.7083C13.7333 9.11621 14.5583 9.98288 14.5583 11.0579" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.7734 8V18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div class="my-auto flex-fill">
                            <p class="my-auto section-title">Allow DCC Markup Refund</p>
                            <p class="mb-0 mt-1 section-text">
                                Enable multi-currency checkout which presents local currencies to your customers.
                            </p>
                        </div>
                        <switch-input v-model="toggleItems.is_dcc_markup_refund_usage_enabled" @input="updateToggle('is_dcc_markup_refund_usage_enabled')" :value="toggleItems.is_dcc_markup_refund_usage_enabled" />
                    </div>
                </div>
            </div>
    
        </div>
    </div>
</template>

<style lang="scss" scoped>
.toggle-settings {
    margin-top: 24px;
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #DCDAD5;
}
::v-deep .custom-control-label::before {
    border-color: #000 !important;
}
::v-deep .custom-control-input:checked ~ .custom-control-label::before{
    border-color: #000 !important;
}
::v-deep .custom-control-input:checked ~ .custom-control-label::before{
    background-color: #000 !important;
}
::v-deep .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.5 3.625L5.3125 9.8125L2.5 7" stroke="white" stroke-width="1.6666" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}
::v-deep .currency-multiselect .multiselect__option--highlight, .currency-multiselect .multiselect__option--highlight:after {
    background: rgba(220, 218, 213, 0.30) !important;
    color: #000 !important;
}

::v-deep .currency-multiselect .multiselect__option--group-selected::after {
    display: none !important;
}
::v-deep .currency-multiselect .multiselect__option {
    min-height: auto;
    padding: 0;
}
.option__desc {
    padding: 12px;
}
::v-deep.is-invalid > .multiselect__tags {
  border-color: #ff3d60 !important;
}
::v-deep .currency-multiselect .multiselect--active > .multiselect__tags {
    border: 1px solid rgba(252, 107, 45, 0.70) !important;
    box-shadow: 0px 0px 0px 4px rgba(248, 88, 19, 0.10) !important;
}
::v-deep .multiselect__input::placeholder {
    color: rgba(0, 0, 0, 0.3) !important;
    font-weight: 500 !important;
}
.section-title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 700;
}
.section-text {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
}
</style>
